import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
`;

export default Row;
